import { Component, OnInit, ViewChild } from '@angular/core';
import { PurchaseAssessmentModalComponent } from "app/purchase-assessment-modal/purchase-assessment-modal.component";
import * as $ from 'jquery';
import 'datatables.net';
//import { AssignAssesmentsModalComponent } from "app/coach/assign-assesments-modal/assign-assesments-modal.component";
import { AssignAssesmentsNewModalComponent } from "app/coach/assign-assesments-new-modal/assign-assesments-new-modal.component";
import { GridOptions } from "ag-grid/main";
import { Globals } from '../../globals';
import { CoachService } from 'app/services/coach/CoachService';

@Component({
  selector: 'app-unassigned-assessments',
  templateUrl: './unassigned-assessments.component.html',
  styleUrls: ['./unassigned-assessments.component.scss']
})
export class UnassignedAssessmentsComponent implements OnInit {
    @ViewChild('purchaseAssessment', {static: true}) public purchaseAssessmentModal: PurchaseAssessmentModalComponent;
    //@ViewChild('assignAssessment') public assignAssessmentModal: AssignAssesmentsModalComponent;
    @ViewChild('assignAssessmentNew', {static: true}) public assignAssessmentModal: AssignAssesmentsNewModalComponent;

    assessments: any[] = [];
    assessmentsHeaders: any[];
    gridOptions: GridOptions;
    regularGridApi;
    gridApi360;
    gridColumnApi;
    overlayNoRowsTemplate;

    height: number;
    count: number;

    loading: boolean = true;
    canAssign: boolean = false;
    rowSelection;
    assessmentType: number = 1;
    modalIndex: number;

    constructor(
        public _Globals: Globals,
        private _CoachService: CoachService
    ) {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
        this.rowSelection = "single";
    }

    ngOnInit() {
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.assessmentsHeaders = this.createHeaders();

        //this.getCoachAvailableAssessments();
        this.getCoachAvailableAssessmentsByType(1);
        this.getCoachAvailableAssessmentsByType(2);
        
    }

    showAvailableTabs() {
        $('.availableTabs div').removeClass('active in');
        $('.availableTabs li').removeClass('active');
        $('.availableTabs li').eq(0).addClass('active');
        $('#Tab1').addClass('active');
        $('#Tab1').addClass('in');
    }

    //getCoachAvailableAssessments() {
    //    this._GetCoachAvailableAssessments.GetCoachAvailableAssessments(this._Globals.getUserId()).subscribe(data => {
    //        console.log('response_GetCoachAvailableAssessments', data.result);
    //        //this.assessments = data.result;
    //        this.loading = false;
    //        this._Globals.unassignedAssessments = data.result;
    //    });
    //}

    getCoachAvailableAssessmentsByType(assessmentType:number) {
        this._CoachService.getCoachAvailableAssessmentsByType(assessmentType).subscribe((data: any) => {
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('response_GetCoachAvailableAssessmentsByType', _data);

                if (assessmentType === 1) {
                    this._Globals.availableAsessmentsRegular = _data;
                } else {
                    this._Globals.availableAsessments360 = _data;
                }

                this.loading = false;

            } 

        });
    }

    tabSelected(index) {
        console.log(index);
        this.assessmentType = index;
        this.deselectAllCheckBox(this.regularGridApi);
        this.deselectAllCheckBox(this.gridApi360);

        if (index === 0.1) {
            this.sizeToFit(this.regularGridApi);
        } else {
            this.sizeToFit(this.gridApi360);
            this._Globals.assessmentsTypeFlag = undefined;
        }
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 500);
    }

    deselectAllCheckBox(gridApi) {
        gridApi.forEachNode(function (node) {
            node.setSelected(false);
        });
    }

    
    openModal() {
        this.purchaseAssessmentModal.show(this);
    }

    openAssignAssessmentModal(assessmentId: number, amount: number,assessmentName:string, is360: boolean) {
        this.modalIndex = 0;
        this.assignAssessmentModal.show(this, false, is360, amount, assessmentName, assessmentId, undefined);
    }

    //assign() {
    //    if (this.canAssign) {
    //        let selected = this.getSelectedRows();
    //        console.log(selected);
    //        this.openAssignAssessmentModal(selected[0].AssessmentId);
    //    }
    //}

    mouseEnter() {
        $('h1').css("padding-bottom", "0px");
    }

    onSelectionChangedChoiceSet(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount == 1) {
            this.canAssign = true;
        } else {
            this.canAssign = false;
        }
    }

    getSelectedRows(gridApi): any {
        console.log("SELECTED", gridApi.getSelectedRows());
        return gridApi.getSelectedRows();
    }

    onResize(event: any) {
        //console.log("Width: " , event.currentTarget.innerWidth);
        //console.log("Height: " , event.currentTarget.innerHeight);
        setTimeout(() => {
            if (this.assessmentType === 1.1) {
                if (this.regularGridApi != undefined) {
                    this.sizeToFit(this.regularGridApi);
                }
            } else {
                if (this.gridApi360 != undefined) {
                    this.sizeToFit(this.gridApi360);
                }
            }
        }, 500);
    }


    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit(gridApi) {
        gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(assessmentType: number, params) {
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
        if (assessmentType === 1) {
            this.regularGridApi = params.api;
            this._Globals.unassignedAssessmentGridApi = params.api;
            this.sizeToFit(this.regularGridApi);
        } else {
            this.gridApi360 = params.api;
        }

    }

    createHeaders() {
        let columnDefs = new Array();

        //let actionsHeader = {
        //    headerName: 'Actions',
        //    field: '',
        //    minWidth: 85,
        //    width:85,
        //    suppressSizeToFit: true,
        //    suppressSorting: true,
        //    suppressMenu: true,
        //    cellRenderer: function (params) {
        //        let content = '';

        //        content += '<i id="assingAction" class="material-icons custom-icons">person</i>';

        //        return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';

        //    }
        //};
        //columnDefs.push(actionsHeader);

        //let checkHeader = {
        //    headerName: '',
        //    field: '',
        //    headerCheckboxSelection: true,
        //    headerCheckboxSelectionFilteredOnly: true,
        //    checkboxSelection: true,
        //    minWidth: 30,
        //    width: 30,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return '';
        //    }
        //};
        //columnDefs.push(checkHeader);

        let nameHeader = {
            headerName: 'Name',
            field: 'AssessmentName',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(nameHeader);

        let quantityHeader = {
            headerName: 'Quantity',
            field: 'Amount',
            minWidth: 120,
            width: 120,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
            }
        };
        columnDefs.push(quantityHeader);

        //let nicheHeader = {
        //    headerName: 'Niche',
        //    field: 'Niche',
        //    minWidth: 90,
        //    width: 200,
        //    suppressSizeToFit: false,
        //    cellRenderer: function (params) {
        //        return '<div style="overflow:hidden !important;text-overflow:ellipsis;">' + params.value + '</div>';
        //    }
        //};
        //columnDefs.push(nicheHeader);

        //let versionHeader = {
        //    headerName: 'Version',
        //    field: '',
        //    minWidth: 120,
        //    width: 120,
        //    suppressSizeToFit: true,
        //    cellRenderer: function (params) {
        //        let version = params.data['MajorVersion'] + "." + params.data['MinorVersion'];
        //        return version;
        //    }
        //};
        //columnDefs.push(versionHeader);

        return columnDefs;
    }

    public onRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
            this.openAssignAssessmentModal(data['AssessmentId'], data['Amount'], data['AssessmentName'], data['Is360']);

            //switch (e.event.target.id) {
            //    case "assingAction":
            //        {
            //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
            //            //this.edit(data['Id'], data['Text']);
            //            this.openAssignAssessmentModal(data['AssessmentId']);
            //            break;
            //        }
            //}
        }
    }

    edit(id: number, text: string) {
        console.log('edit');
    }
    

}
